import { useMemo } from "react";
import { useSelector } from "react-redux";

import { Ubigeo } from "../../../../models/ubigeo";
import { ENV } from "../../../../constants/env";

export default function useLocationOptions() {
    const { ubigeos } = useSelector(state => ({
        ubigeos: state.HomeInsurance.ubigeos,
    }));
    const locationOptions = useMemo(() => {
        if (!ubigeos) return [];
        return ubigeos
            .filter(
                ({ department }) =>
                    !ENV.LANDING.CALCULATOR_RESTRICTED ||
                    department === "Callao" ||
                    department === "Lima"
            )
            .map((ub = new Ubigeo()) => ({
                label: ub.location,
                value: ub.ubigeo,
                district: ub.district
            }));
    }, [ubigeos]);
    return { locationOptions };
}
